import { useTranslation } from "react-i18next";

import Error404Logo from "src/core/assets/images/error404logo.svg?react";

export const Error404 = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full flex flex-col items-center h-full pt-60px">
      <Error404Logo />
      <div className="mt-10 font-light text-primary text-lg">{t("error.404")}</div>
    </div>
  );
};
